"use client";
import { Action } from "@/context/AnalyticsProvider";
import { useGamePageV3Analytics } from "@/context/AnalyticsProvider/gamePageV3";
import { useEffect } from "react";
import { GamePageModal } from "../GamePageModal";

interface VideoModalProps {
  isModalOpen: boolean;
  handleOpenChange: (open: boolean) => void;
  videoUrl?: string;
  gameTitle?: string;
  gameIcon?: string;
  gameId?: string;
}

export const VideoModal = ({
  isModalOpen,
  handleOpenChange,
  videoUrl,
  gameTitle,
  gameIcon,
  gameId,
}: VideoModalProps) => {
  const { track } = useGamePageV3Analytics();

  useEffect(() => {
    if (isModalOpen && gameId) {
      track({
        action: Action.VIEWED,
        extras: {
          id: "video-modal",
          gameId,
          gameName: gameTitle,
        },
      });
    }
  }, [isModalOpen, gameId, gameTitle, track]);

  return (
    <GamePageModal
      title={`${gameTitle ?? "Game"} Official Trailer`}
      gameTitle={gameTitle ?? "Game Title"}
      gameIcon={gameIcon}
      isModalOpen={isModalOpen}
      setIsModalOpen={handleOpenChange}
      gameId={gameId}
      className="h-[95%] sm:h-[90%] top-[52.5%] sm:top-1/2 before:rounded-b-none [&>div]:rounded-b-none sm:before:rounded-b-[1.25rem] sm:[&>div]:rounded-b-[1.25rem]"
    >
      {/* biome-ignore lint/a11y/useMediaCaption: <explanation> */}
      <video
        src={videoUrl}
        autoPlay={isModalOpen}
        controls
        loop
        playsInline
        preload="metadata"
        className="relative h-full w-full mx-auto rounded-b-none sm:rounded-b-[1.25rem] overflow-hidden cursor-pointer"
      />
    </GamePageModal>
  );
};
